import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ModalComponent } from '../modal/modal.component';
import { BaseMenuComponent } from './base.menu';
import { Inspection } from '../shared/models';
import { PeopleService } from '../shared/services/people.service';

@Component({
    templateUrl: './part.menu.html',
    standalone: false
})
export class PartMenuComponent extends BaseMenuComponent {
  public currentPerson: any;
  public inspection: Inspection;
  public pointId: string;

  constructor(public modal: ModalComponent, private route: ActivatedRoute, private peopleService: PeopleService) {
    super(modal);
    this.peopleService.getCurrent().subscribe((res) => (this.currentPerson = res));
  }

  public init(data: any) {
    this.inspection = data.inspection;
    this.pointId = this.route.snapshot.paramMap.get('pointId');
  }
}
